import { AlertTriangle } from "lucide-react";

export const IssuesList = ({ tests }) => {
  const bad = tests.filter((t) => t.issues.length);
  return (
    <div className="h-[460px] flex flex-col" data-testid="issues-list">
      <div className="px-4 py-3 border-b border-white/10 flex justify-between items-center">
        <span className="label">Issues</span>
        <span className="text-xs bg-[#FF3B30] text-white px-2 py-0.5" data-testid="issues-count">{bad.length}</span>
      </div>
      <div className="overflow-y-auto flex-1">
        {!bad.length && <div className="p-4 text-xs text-neutral-600">No issues. All tests within thresholds.</div>}
        {bad.map((t) => (
          <div key={t.id} className="px-4 py-3 border-b border-white/10 border-l-2 border-l-[#FF3B30] hover:bg-white/[0.03]" data-testid={`issue-item-${t.id}`}>
            <div className="flex justify-between text-xs">
              <span className="text-white">{t.rep_name} <span className="text-neutral-500">· {t.team}</span></span>
              <span className="text-neutral-600">{new Date(t.created_at).toLocaleDateString()}</span>
            </div>
            <div className="text-[11px] text-neutral-500 mt-0.5">{t.location?.city || "Unknown location"}{t.isp ? ` · ${t.isp}` : ""}</div>
            {t.issues.map((i) => (
              <div key={i} className="text-[11px] text-[#FF3B30] flex gap-1 mt-1"><AlertTriangle className="w-3 h-3" />{i}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
